import { useState, useEffect, useRef } from "react";
import "@/App.css";
import { ArrowUpRight, Globe, Plus } from "lucide-react";

const IMAGES = {
  logo: "https://customer-assets.emergentagent.com/job_2444a3e9-b2d1-4868-be5e-95a889ecd942/artifacts/e6una3lq_customcolor_logo_transparent_background.png",
  work1: "https://customer-assets.emergentagent.com/job_2444a3e9-b2d1-4868-be5e-95a889ecd942/artifacts/q11jrk5w_Raudoitus1.png",
  work2: "https://customer-assets.emergentagent.com/job_2444a3e9-b2d1-4868-be5e-95a889ecd942/artifacts/eot9vswf_Raudoitus3.png",
  work3: "https://customer-assets.emergentagent.com/job_2444a3e9-b2d1-4868-be5e-95a889ecd942/artifacts/iyw9iozz_Raudoitus%2031.png",
  work4: "https://customer-assets.emergentagent.com/job_2444a3e9-b2d1-4868-be5e-95a889ecd942/artifacts/wzt48cpa_Raudoitus55.png",
  work5: "https://customer-assets.emergentagent.com/job_2444a3e9-b2d1-4868-be5e-95a889ecd942/artifacts/kr8j9x7g_Raudoitus66.png",
  hero: "https://customer-assets.emergentagent.com/job_14820bb8-49f2-40dc-b7c3-0a05e2a40115/artifacts/85hzkn7n_7P9A0726.JPG",
  stegra: "https://customer-assets.emergentagent.com/job_14820bb8-49f2-40dc-b7c3-0a05e2a40115/artifacts/akeh403q_DJI_20241028093629_0040_V.JPG",
  pahkakoski: "https://customer-assets.emergentagent.com/job_14820bb8-49f2-40dc-b7c3-0a05e2a40115/artifacts/dpgzi731_kuva%20raudoitus.png",
  joni: "https://customer-assets.emergentagent.com/job_14820bb8-49f2-40dc-b7c3-0a05e2a40115/artifacts/mykfl5nn_joni%20valkoinen.png",
  windAerial: "https://customer-assets.emergentagent.com/job_14820bb8-49f2-40dc-b7c3-0a05e2a40115/artifacts/wbye05ru_DJI_0726.jpg",
  windCage: "https://customer-assets.emergentagent.com/job_14820bb8-49f2-40dc-b7c3-0a05e2a40115/artifacts/gai2rgko_DJI_0750.jpg",
  windCrane: "https://customer-assets.emergentagent.com/job_14820bb8-49f2-40dc-b7c3-0a05e2a40115/artifacts/p65w5nrw_DJI_0814.jpg",
  windAnchor: "https://customer-assets.emergentagent.com/job_14820bb8-49f2-40dc-b7c3-0a05e2a40115/artifacts/t0m0weix_DJI_0842.jpg",
  kamil: "https://customer-assets.emergentagent.com/job_2444a3e9-b2d1-4868-be5e-95a889ecd942/artifacts/nel21dvw_image.png",
  patryk: "https://customer-assets.emergentagent.com/job_2444a3e9-b2d1-4868-be5e-95a889ecd942/artifacts/tqt89ij1_image.png"
};

const translations = {
  fi: {
    nav: {
      capabilities: "Osaaminen",
      projects: "Projektit",
      team: "Tiimi",
      careers: "Töihin meille",
      contact: "Yhteystiedot",
      cta: "Keskustellaan"
    },
    hero: {
      eyebrow: "Arctic Rebar — Betoniraudoituksen ammattilainen",
      title1: "Luotettavaa raudoitusta",
      title2: "vaativiin teollisuusprojekteihin.",
      subtitle: "Vaativia betoniraudoitustöitä Suomessa ja Ruotsissa. Laatu, turvallisuus ja hallittu toteutus jokaisessa hankkeessa.",
      cta1: "Tutustu referensseihin",
      cta2: "Keskustellaan hankkeestasi",
      scroll: "Vieritä"
    },
    metrics: {
      eyebrow: "Toiminta lukuina",
      items: [
        { value: "15 M€+", label: "Liikevaihto 2025" },
        { value: "20 M+ kg", label: "Asennettua raudoitusta" },
        { value: "FI · SE", label: "Toimialueet" },
        { value: "Teollisuus & Infra", label: "Toimialat" }
      ]
    },
    capabilities: {
      eyebrow: "Osaaminen",
      title: "Mitä toteutamme",
      subtitle: "Raudoitustyöt teollisuus- ja infrarakentamiseen.",
      items: [
        { number: "01", title: "Teollisuusrakentamisen raudoitus", desc: "Tuotantolaitosten ja prosessirakenteiden betoniraudoitus uusinvestointeihin." },
        { number: "02", title: "Infrarakenteet", desc: "Siltojen, tukimuurien ja muiden kantavien betonirakenteiden raudoitus." },
        { number: "03", title: "Energiarakentaminen", desc: "Tuulivoima- ja energiatuotannon perustusten betoniraudoitus." },
        { number: "04", title: "Vaativat raudoitushankkeet", desc: "Resurssit, kalusto ja työnjohto mitoitetaan hankkeen laajuuden mukaan." }
      ]
    },
    projects: {
      eyebrow: "Referenssiprojektit",
      title: "Toteutetut hankkeet",
      viewLabel: "Hankkeen tiedot",
      items: [
        {
          number: "01",
          name: "Green Steel Plant",
          location: "Boden, Ruotsi",
          period: "2024 →",
          sector: "Teollisuus",
          detail: "Pohjoismaiden suurin vihreän teräksen tuotantolaitos. Arctic Rebar toteuttaa kohteessa betoniraudoitustöitä.",
          image: "stegra"
        },
        {
          number: "02",
          name: "Pahkakosken Tuulipuisto",
          location: "Ii, Suomi",
          period: "2024",
          sector: "Energia",
          detail: "Betoniraudoitus 30 tuulivoimaperustukseen.",
          image: "windCage"
        },
        {
          number: "03",
          name: "Siikajoen Tuulipuisto",
          location: "Siikajoki, Suomi",
          period: "2023",
          sector: "Energia",
          detail: "Betoniraudoitus 38 tuulivoimaperustukseen.",
          image: "windAerial"
        }
      ]
    },
    why: {
      eyebrow: "Miksi Arctic Rebar",
      title: "Toimintatapamme",
      subtitle: "Kuusi periaatetta, jotka näkyvät jokaisella työmaallamme.",
      items: [
        { number: "01", title: "Luotettava toteutus", desc: "Sovitut aikataulut pitävät. Ilman yllätyksiä." },
        { number: "02", title: "Kokenut työnjohto", desc: "Työmaapäälliköt vastaavat toteutuksesta alusta loppuun." },
        { number: "03", title: "Korkeat turvallisuusstandardit", desc: "Nollatoleranssi tapaturmille. Turvallisuus ohjaa kaikkea toimintaamme." },
        { number: "04", title: "Tekninen tarkkuus", desc: "Suunnitelmanmukainen toteutus jokaisessa rakenneosassa." },
        { number: "05", title: "Skaalautuva työvoima", desc: "Lisätyövoimaa ja työnjohtoa kun työmaa kasvaa." },
        { number: "06", title: "Suorituskyky pohjoisissa olosuhteissa", desc: "Talvi, kylmyys, suuret kohteet — toimimme pohjoisen ehdoilla." }
      ]
    },
    team: {
      eyebrow: "Tiimi",
      title: "Vastuussa toteutuksesta",
      subtitle: "Operatiivinen johto vastaa raudoitustöiden suunnittelusta, työnjohdosta ja toteutuksesta.",
      joniTitle: "Operatiivinen päällikkö",
      kamilTitle: "Työmaapäällikkö",
      patrykTitle: "Työmaapäällikkö"
    },
    careers: {
      eyebrow: "Töihin meille",
      title: "Tule osaksi Arctic Rebarin tiimiä",
      subtitle: "Etsimme ammattitaitoisia raudoittajia hankkeisiimme Suomessa ja Ruotsissa. Ota yhteyttä työmaapäällikköihin.",
      contactLabel: "Rekrytointi"
    },
    contact: {
      eyebrow: "Yhteystiedot",
      title: "Keskustellaan hankkeestasi.",
      subtitle: "Ota yhteyttä ja kerro hankkeestasi. Vastaamme yhteydenottoosi nopeasti.",
      directLabel: "Suora yhteys",
      officeLabel: "Toimisto",
      address1: "Liuskekuja 3 LT 9",
      address2: "90620 Oulu, Suomi"
    },
    footer: {
      positioning: "Raudoitustyöt vaativiin teollisuus- ja infrahankkeisiin Pohjoismaissa.",
      contactLabel: "Yhteys",
      officeLabel: "Toimipiste",
      rights: "Kaikki oikeudet pidätetään.",
      tagline: "Pohjoismainen teollisuusraudoitus."
    }
  },
  en: {
    nav: {
      capabilities: "Capabilities",
      projects: "Projects",
      team: "Team",
      careers: "Careers",
      contact: "Contact",
      cta: "Discuss"
    },
    hero: {
      eyebrow: "Arctic Rebar — Concrete reinforcement specialists",
      title1: "Reliable reinforcement execution",
      title2: "for demanding industrial projects.",
      subtitle: "Demanding concrete reinforcement work in Finland and Sweden. Quality, safety and controlled execution on every project.",
      cta1: "View references",
      cta2: "Discuss your project",
      scroll: "Scroll"
    },
    metrics: {
      eyebrow: "Operations in numbers",
      items: [
        { value: "€15M+", label: "Revenue 2025" },
        { value: "20M+ kg", label: "Rebar installed" },
        { value: "FI · SE", label: "Operating regions" },
        { value: "Industrial & Infra", label: "Sectors" }
      ]
    },
    capabilities: {
      eyebrow: "Capabilities",
      title: "What we deliver",
      subtitle: "Reinforcement works for industrial and infrastructure construction.",
      items: [
        { number: "01", title: "Industrial reinforcement", desc: "Concrete reinforcement for new production facilities and process structures." },
        { number: "02", title: "Infrastructure reinforcement", desc: "Reinforcement of bridges, retaining walls and other load-bearing concrete structures." },
        { number: "03", title: "Energy construction", desc: "Concrete reinforcement of wind power and energy production foundations." },
        { number: "04", title: "Demanding reinforcement projects", desc: "Resources, equipment and management scale with project size." }
      ]
    },
    projects: {
      eyebrow: "Reference projects",
      title: "Delivered projects",
      viewLabel: "Project details",
      items: [
        {
          number: "01",
          name: "Green Steel Plant",
          location: "Boden, Sweden",
          period: "2024 →",
          sector: "Industrial",
          detail: "The largest green steel production facility in the Nordics. Arctic Rebar carries out concrete reinforcement work on site.",
          image: "stegra"
        },
        {
          number: "02",
          name: "Pahkakoski Wind Farm",
          location: "Ii, Finland",
          period: "2024",
          sector: "Energy",
          detail: "Concrete reinforcement of 30 wind turbine foundations.",
          image: "windCage"
        },
        {
          number: "03",
          name: "Siikajoki Wind Farm",
          location: "Siikajoki, Finland",
          period: "2023",
          sector: "Energy",
          detail: "Concrete reinforcement of 38 wind turbine foundations.",
          image: "windAerial"
        }
      ]
    },
    why: {
      eyebrow: "Why Arctic Rebar",
      title: "How we operate",
      subtitle: "Six principles that show up on every site.",
      items: [
        { number: "01", title: "Reliable delivery", desc: "Agreed schedules hold. No surprises." },
        { number: "02", title: "Experienced site management", desc: "Site managers own the execution from start to finish." },
        { number: "03", title: "High safety standards", desc: "Zero tolerance for accidents. Safety guides everything we do." },
        { number: "04", title: "Technical precision", desc: "Built to plan, in every structural element." },
        { number: "05", title: "Scalable workforce", desc: "Additional workforce and supervision when the site grows." },
        { number: "06", title: "Performance in northern conditions", desc: "Winter, cold, scale — we work on the North's terms." }
      ]
    },
    team: {
      eyebrow: "Team",
      title: "Responsible for execution",
      subtitle: "Operational leadership owns the planning of reinforcement works, supervision and execution.",
      joniTitle: "Operations Manager",
      kamilTitle: "Site Manager",
      patrykTitle: "Site Manager"
    },
    careers: {
      eyebrow: "Careers",
      title: "Become part of the Arctic Rebar team",
      subtitle: "We are hiring skilled reinforcement workers for projects in Finland and Sweden. Contact our site managers directly.",
      contactLabel: "Recruitment"
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's discuss your project.",
      subtitle: "Get in touch and tell us about your project. We respond promptly.",
      directLabel: "Direct contact",
      officeLabel: "Office",
      address1: "Liuskekuja 3 LT 9",
      address2: "90620 Oulu, Finland"
    },
    footer: {
      positioning: "Concrete reinforcement services for demanding industrial and infrastructure projects across the Nordics.",
      contactLabel: "Contact",
      officeLabel: "Office",
      rights: "All rights reserved.",
      tagline: "Nordic industrial reinforcement."
    }
  },
  pl: {
    nav: {
      capabilities: "Kompetencje",
      projects: "Projekty",
      team: "Zespół",
      careers: "Praca u nas",
      contact: "Kontakt",
      cta: "Porozmawiajmy"
    },
    hero: {
      eyebrow: "Arctic Rebar — Specjaliści w zbrojeniu betonu",
      title1: "Niezawodne zbrojenie",
      title2: "do wymagających projektów przemysłowych.",
      subtitle: "Wymagające prace zbrojarskie betonu w Finlandii i Szwecji. Jakość, bezpieczeństwo i kontrolowana realizacja w każdym projekcie.",
      cta1: "Zobacz referencje",
      cta2: "Porozmawiajmy o projekcie",
      scroll: "Przewiń"
    },
    metrics: {
      eyebrow: "Działalność w liczbach",
      items: [
        { value: "15 mln €+", label: "Przychody 2025" },
        { value: "20 mln+ kg", label: "Zamontowanego zbrojenia" },
        { value: "FI · SE", label: "Obszary działania" },
        { value: "Przemysł & Infra", label: "Sektory" }
      ]
    },
    capabilities: {
      eyebrow: "Kompetencje",
      title: "Co realizujemy",
      subtitle: "Prace zbrojarskie dla budownictwa przemysłowego i infrastrukturalnego.",
      items: [
        { number: "01", title: "Zbrojenie przemysłowe", desc: "Zbrojenie betonu dla nowych zakładów produkcyjnych i konstrukcji procesowych." },
        { number: "02", title: "Zbrojenie infrastruktury", desc: "Zbrojenie mostów, murów oporowych i innych nośnych konstrukcji betonowych." },
        { number: "03", title: "Budownictwo energetyczne", desc: "Zbrojenie fundamentów betonowych elektrowni wiatrowych i produkcji energii." },
        { number: "04", title: "Wymagające projekty zbrojarskie", desc: "Zasoby, sprzęt i kierownictwo skalują się wraz z wielkością projektu." }
      ]
    },
    projects: {
      eyebrow: "Projekty referencyjne",
      title: "Zrealizowane projekty",
      viewLabel: "Szczegóły projektu",
      items: [
        {
          number: "01",
          name: "Green Steel Plant",
          location: "Boden, Szwecja",
          period: "2024 →",
          sector: "Przemysł",
          detail: "Największy nordycki zakład produkcji zielonej stali. Arctic Rebar realizuje na obiekcie prace zbrojarskie betonu.",
          image: "stegra"
        },
        {
          number: "02",
          name: "Farma Wiatrowa Pahkakoski",
          location: "Ii, Finlandia",
          period: "2024",
          sector: "Energia",
          detail: "Zbrojenie 30 betonowych fundamentów turbin wiatrowych.",
          image: "windCage"
        },
        {
          number: "03",
          name: "Farma Wiatrowa Siikajoki",
          location: "Siikajoki, Finlandia",
          period: "2023",
          sector: "Energia",
          detail: "Zbrojenie 38 betonowych fundamentów turbin wiatrowych.",
          image: "windAerial"
        }
      ]
    },
    why: {
      eyebrow: "Dlaczego Arctic Rebar",
      title: "Jak działamy",
      subtitle: "Sześć zasad widocznych na każdej budowie.",
      items: [
        { number: "01", title: "Niezawodna realizacja", desc: "Ustalone harmonogramy są dotrzymywane. Bez niespodzianek." },
        { number: "02", title: "Doświadczone kierownictwo budowy", desc: "Kierownicy budowy odpowiadają za realizację od początku do końca." },
        { number: "03", title: "Wysokie standardy bezpieczeństwa", desc: "Zerowa tolerancja dla wypadków. Bezpieczeństwo kieruje wszystkim, co robimy." },
        { number: "04", title: "Techniczna precyzja", desc: "Zgodnie z projektem, w każdym elemencie konstrukcyjnym." },
        { number: "05", title: "Skalowalny zespół", desc: "Dodatkowy zespół i nadzór, gdy budowa się rozrasta." },
        { number: "06", title: "Wydajność w warunkach północnych", desc: "Zima, mróz, skala – pracujemy na warunkach Północy." }
      ]
    },
    team: {
      eyebrow: "Zespół",
      title: "Odpowiedzialni za realizację",
      subtitle: "Kierownictwo operacyjne odpowiada za planowanie prac zbrojarskich, nadzór i realizację.",
      joniTitle: "Kierownik Operacyjny",
      kamilTitle: "Kierownik Budowy",
      patrykTitle: "Kierownik Budowy"
    },
    careers: {
      eyebrow: "Praca u nas",
      title: "Dołącz do zespołu Arctic Rebar",
      subtitle: "Zatrudniamy wykwalifikowanych zbrojarzy do projektów w Finlandii i Szwecji. Skontaktuj się bezpośrednio z naszymi kierownikami budowy.",
      contactLabel: "Rekrutacja"
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Porozmawiajmy o Twoim projekcie.",
      subtitle: "Skontaktuj się i opowiedz o swoim projekcie. Odpowiadamy szybko.",
      directLabel: "Kontakt bezpośredni",
      officeLabel: "Biuro",
      address1: "Liuskekuja 3 LT 9",
      address2: "90620 Oulu, Finlandia"
    },
    footer: {
      positioning: "Zbrojenie konstrukcji betonowych do wymagających projektów przemysłowych i infrastrukturalnych w krajach nordyckich.",
      contactLabel: "Kontakt",
      officeLabel: "Biuro",
      rights: "Wszelkie prawa zastrzeżone.",
      tagline: "Nordyckie zbrojenie przemysłowe."
    }
  },
  sv: {
    nav: {
      capabilities: "Kompetens",
      projects: "Projekt",
      team: "Team",
      careers: "Karriär",
      contact: "Kontakt",
      cta: "Diskutera"
    },
    hero: {
      eyebrow: "Arctic Rebar — Specialister på betongarmering",
      title1: "Pålitlig armering",
      title2: "för krävande industriprojekt.",
      subtitle: "Krävande betongarmering i Finland och Sverige. Kvalitet, säkerhet och kontrollerat utförande i varje projekt.",
      cta1: "Se referenser",
      cta2: "Diskutera ditt projekt",
      scroll: "Skrolla"
    },
    metrics: {
      eyebrow: "Verksamhet i siffror",
      items: [
        { value: "15 M€+", label: "Omsättning 2025" },
        { value: "20 M+ kg", label: "Installerad armering" },
        { value: "FI · SE", label: "Verksamhetsområden" },
        { value: "Industri & Infra", label: "Sektorer" }
      ]
    },
    capabilities: {
      eyebrow: "Kompetens",
      title: "Vad vi levererar",
      subtitle: "Armeringsarbeten för industri- och infrastrukturbyggnation.",
      items: [
        { number: "01", title: "Industriell armering", desc: "Betongarmering för nya produktionsanläggningar och processkonstruktioner." },
        { number: "02", title: "Infrastrukturarmering", desc: "Armering av broar, stödmurar och andra bärande betongkonstruktioner." },
        { number: "03", title: "Energibyggnation", desc: "Betongarmering av vindkrafts- och energiproduktionsfundament." },
        { number: "04", title: "Krävande armeringsprojekt", desc: "Resurser, utrustning och arbetsledning skalas efter projektets omfattning." }
      ]
    },
    projects: {
      eyebrow: "Referensprojekt",
      title: "Genomförda projekt",
      viewLabel: "Projektinformation",
      items: [
        {
          number: "01",
          name: "Green Steel Plant",
          location: "Boden, Sverige",
          period: "2024 →",
          sector: "Industri",
          detail: "Nordens största anläggning för grönt stål. Arctic Rebar utför betongarmering på objektet.",
          image: "stegra"
        },
        {
          number: "02",
          name: "Pahkakoski Vindkraftpark",
          location: "Ii, Finland",
          period: "2024",
          sector: "Energi",
          detail: "Betongarmering av 30 vindkraftverksfundament.",
          image: "windCage"
        },
        {
          number: "03",
          name: "Siikajoki Vindkraftpark",
          location: "Siikajoki, Finland",
          period: "2023",
          sector: "Energi",
          detail: "Betongarmering av 38 vindkraftverksfundament.",
          image: "windAerial"
        }
      ]
    },
    why: {
      eyebrow: "Varför Arctic Rebar",
      title: "Så här arbetar vi",
      subtitle: "Sex principer som syns på varje arbetsplats.",
      items: [
        { number: "01", title: "Pålitlig leverans", desc: "Överenskomna tidsplaner håller. Utan överraskningar." },
        { number: "02", title: "Erfaren arbetsledning", desc: "Platscheferna ansvarar för utförandet från början till slut." },
        { number: "03", title: "Höga säkerhetsstandarder", desc: "Nolltolerans mot olyckor. Säkerheten styr allt vi gör." },
        { number: "04", title: "Teknisk precision", desc: "Utfört enligt ritning i varje konstruktionsdel." },
        { number: "05", title: "Skalbar arbetsstyrka", desc: "Extra arbetskraft och arbetsledning när projektet växer." },
        { number: "06", title: "Prestanda i nordiska förhållanden", desc: "Vinter, kyla, stora objekt — vi arbetar på Nordens villkor." }
      ]
    },
    team: {
      eyebrow: "Team",
      title: "Ansvariga för utförandet",
      subtitle: "Den operativa ledningen ansvarar för planering av armeringsarbetet, arbetsledning och utförande.",
      joniTitle: "Operativ chef",
      kamilTitle: "Platschef",
      patrykTitle: "Platschef"
    },
    careers: {
      eyebrow: "Karriär",
      title: "Bli en del av Arctic Rebar-teamet",
      subtitle: "Vi söker skickliga armerare för våra projekt i Finland och Sverige. Kontakta våra platschefer direkt.",
      contactLabel: "Rekrytering"
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Låt oss diskutera ditt projekt.",
      subtitle: "Kontakta oss och berätta om ditt projekt. Vi återkommer snabbt.",
      directLabel: "Direktkontakt",
      officeLabel: "Kontor",
      address1: "Liuskekuja 3 LT 9",
      address2: "90620 Uleåborg, Finland"
    },
    footer: {
      positioning: "Betongarmering för krävande industri- och infrastrukturprojekt i Norden.",
      contactLabel: "Kontakt",
      officeLabel: "Kontor",
      rights: "Alla rättigheter förbehållna.",
      tagline: "Nordisk industriell armering."
    }
  }
};

// ===== Navigation =====
const Navigation = ({ lang, setLang, t }) => {
  const [scrolled, setScrolled] = useState(false);
  const [langOpen, setLangOpen] = useState(false);
  const langRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close language menu on outside click (works on desktop AND mobile)
  useEffect(() => {
    if (!langOpen) return;
    const onDocClick = (e) => {
      if (langRef.current && !langRef.current.contains(e.target)) {
        setLangOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("touchstart", onDocClick);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("touchstart", onDocClick);
    };
  }, [langOpen]);

  const items = [
    { id: "capabilities", label: t.nav.capabilities },
    { id: "projects", label: t.nav.projects },
    { id: "team", label: t.nav.team },
    { id: "careers", label: t.nav.careers },
    { id: "contact", label: t.nav.contact }
  ];

  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  const languages = [
    { code: "fi", label: "FI" },
    { code: "en", label: "EN" },
    { code: "sv", label: "SV" },
    { code: "pl", label: "PL" }
  ];

  return (
    <header className={`nav ${scrolled ? "nav--scrolled" : ""}`} data-testid="navigation">
      <div className="nav__inner">
        <a href="#hero" className="nav__brand" data-testid="nav-brand">
          <img src={IMAGES.logo} alt="Arctic Rebar" />
        </a>
        <nav className="nav__links" data-testid="nav-links">
          {items.map((it) => (
            <button key={it.id} onClick={() => scrollTo(it.id)} data-testid={`nav-${it.id}`}>
              {it.label}
            </button>
          ))}
        </nav>
        <div className="nav__right">
          <div className="nav__lang" ref={langRef}>
            <button onClick={() => setLangOpen((v) => !v)} className="nav__lang-btn" data-testid="lang-toggle" aria-expanded={langOpen}>
              <Globe size={14} />
              <span>{lang.toUpperCase()}</span>
            </button>
            {langOpen && (
              <div className="nav__lang-menu">
                {languages.map((l) => (
                  <button
                    key={l.code}
                    onClick={() => {
                      setLang(l.code);
                      setLangOpen(false);
                    }}
                    className={lang === l.code ? "active" : ""}
                    data-testid={`lang-option-${l.code}`}
                  >
                    {l.label}
                  </button>
                ))}
              </div>
            )}
          </div>
          <button className="nav__cta" onClick={() => scrollTo("contact")} data-testid="nav-cta">
            <span>{t.nav.cta}</span>
            <ArrowUpRight size={16} />
          </button>
        </div>
      </div>
    </header>
  );
};

// ===== Hero =====
const Hero = ({ t }) => {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="hero" className="hero" data-testid="hero-section">
      <div className="hero__media">
        <img src={IMAGES.stegra} alt="" />
        <div className="hero__veil" />
        <div className="hero__grid" />
      </div>
      <div className="hero__content">
        <span className="eyebrow eyebrow--light" data-testid="hero-eyebrow">{t.hero.eyebrow}</span>
        <h1 className="hero__title" data-testid="hero-title">
          <span className="hero__title-line">{t.hero.title1}</span>
          <span className="hero__title-line hero__title-line--accent">{t.hero.title2}</span>
        </h1>
        <p className="hero__subtitle" data-testid="hero-subtitle">{t.hero.subtitle}</p>
        <div className="hero__cta">
          <button className="btn btn--primary" onClick={() => scrollTo("projects")} data-testid="hero-cta-projects">
            <span>{t.hero.cta1}</span>
            <ArrowUpRight size={18} />
          </button>
          <button className="btn btn--ghost" onClick={() => scrollTo("contact")} data-testid="hero-cta-contact">
            <span>{t.hero.cta2}</span>
            <Plus size={18} />
          </button>
        </div>
      </div>
      <div className="hero__bottom">
        <span className="mono">{t.hero.scroll}</span>
        <span className="hero__bottom-line" />
        <span className="mono">N 65°48&prime;·E 25°22&prime;</span>
      </div>
    </section>
  );
};

// ===== Metrics =====
const Metrics = ({ t }) => (
  <section className="metrics" data-testid="metrics-section">
    <div className="container">
      <span className="eyebrow">{t.metrics.eyebrow}</span>
      <div className="metrics__grid">
        {t.metrics.items.map((m, i) => (
          <div key={i} className="metric" data-testid={`metric-${i}`}>
            <span className="metric__index mono">0{i + 1}</span>
            <span className="metric__value">{m.value}</span>
            <span className="metric__label">{m.label}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

// ===== Capabilities =====
const Capabilities = ({ t }) => (
  <section id="capabilities" className="capabilities" data-testid="capabilities-section">
    <div className="container">
      <div className="section-head">
        <div>
          <span className="eyebrow">{t.capabilities.eyebrow}</span>
          <h2 className="display">{t.capabilities.title}</h2>
        </div>
        <p className="section-head__lead">{t.capabilities.subtitle}</p>
      </div>
      <ul className="cap-list">
        {t.capabilities.items.map((it, i) => (
          <li key={i} className="cap-item" data-testid={`capability-${i}`}>
            <span className="cap-item__num mono">{it.number}</span>
            <h3 className="cap-item__title">{it.title}</h3>
            <p className="cap-item__desc">{it.desc}</p>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

// ===== Featured Projects =====
const Projects = ({ t }) => (
  <section id="projects" className="projects" data-testid="projects-section">
    <div className="container">
      <div className="section-head">
        <div>
          <span className="eyebrow">{t.projects.eyebrow}</span>
          <h2 className="display">{t.projects.title}</h2>
        </div>
      </div>
    </div>
    <div className="projects__list">
      {t.projects.items.map((p, i) => (
        <article key={i} className="project" data-testid={`project-${i}`}>
          <div className="project__media">
            <img src={IMAGES[p.image]} alt={p.name} loading="lazy" />
            <div className="project__media-veil" />
          </div>
          <div className="container">
            <div className="project__meta">
              <span className="mono project__num">{p.number} / 0{t.projects.items.length}</span>
              <span className="mono project__sector">{p.sector}</span>
              <span className="mono project__period">{p.period}</span>
            </div>
            <h3 className="project__name">{p.name}</h3>
            <p className="project__location">{p.location}</p>
            <p className="project__detail">{p.detail}</p>
          </div>
        </article>
      ))}
    </div>
  </section>
);

// ===== Why =====
const Why = ({ t }) => (
  <section className="why" data-testid="why-section">
    <div className="container">
      <div className="section-head">
        <div>
          <span className="eyebrow">{t.why.eyebrow}</span>
          <h2 className="display">{t.why.title}</h2>
        </div>
        <p className="section-head__lead">{t.why.subtitle}</p>
      </div>
      <ul className="why-list">
        {t.why.items.map((it, i) => (
          <li key={i} className="why-item" data-testid={`why-${i}`}>
            <span className="why-item__num mono">{it.number}</span>
            <div className="why-item__body">
              <h3 className="why-item__title">{it.title}</h3>
              <p className="why-item__desc">{it.desc}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

// ===== Team =====
const Team = ({ t }) => {
  const members = [
    { name: "Joni Kajava", title: t.team.joniTitle, image: IMAGES.joni, phone: "+358 50 475 9055", email: "joni.kajava@arcticrebar.fi" },
    { name: "Kamil Wyskiel", title: t.team.kamilTitle, image: IMAGES.kamil, phone: "+358 44 755 9741", email: "kamil.wyskiel@arcticrebar.fi" },
    { name: "Patryk Okulisz-Kozaryn", title: t.team.patrykTitle, image: IMAGES.patryk, phone: "+358 44 772 0593", email: "patryk.okulicz@arcticrebar.fi" }
  ];
  return (
    <section id="team" className="team" data-testid="team-section">
      <div className="container">
        <div className="section-head">
          <div>
            <span className="eyebrow">{t.team.eyebrow}</span>
            <h2 className="display">{t.team.title}</h2>
          </div>
          <p className="section-head__lead">{t.team.subtitle}</p>
        </div>
        <div className="team__grid">
          {members.map((m, i) => (
            <article key={i} className="team-card" data-testid={`team-${i}`}>
              <div className="team-card__media">
                <img src={m.image} alt={m.name} />
              </div>
              <div className="team-card__body">
                <span className="mono team-card__index">0{i + 1}</span>
                <h3 className="team-card__name">{m.name}</h3>
                <p className="team-card__title">{m.title}</p>
                <div className="team-card__contact">
                  <a href={`tel:${m.phone.replace(/\s/g, "")}`}>{m.phone}</a>
                  <a href={`mailto:${m.email}`}>{m.email}</a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

// ===== Careers =====
const Careers = ({ t }) => {
  const recruiters = [
    { name: "Kamil Wyskiel", title: t.team.kamilTitle, phone: "+358 44 755 9741", email: "kamil.wyskiel@arcticrebar.fi" },
    { name: "Patryk Okulisz-Kozaryn", title: t.team.patrykTitle, phone: "+358 44 772 0593", email: "patryk.okulicz@arcticrebar.fi" }
  ];
  return (
    <section id="careers" className="careers" data-testid="careers-section">
      <div className="container">
        <div className="careers__inner">
          <div className="careers__lead">
            <span className="eyebrow">{t.careers.eyebrow}</span>
            <h2 className="display">{t.careers.title}</h2>
            <p className="careers__sub">{t.careers.subtitle}</p>
          </div>
          <div className="careers__contacts">
            <span className="mono careers__contacts-label">{t.careers.contactLabel}</span>
            {recruiters.map((r, i) => (
              <div key={i} className="careers-contact" data-testid={`careers-contact-${i}`}>
                <div className="careers-contact__name">
                  <span>{r.name}</span>
                  <span className="careers-contact__role">{r.title}</span>
                </div>
                <div className="careers-contact__links">
                  <a href={`tel:${r.phone.replace(/\s/g, "")}`}>{r.phone}</a>
                  <a href={`mailto:${r.email}`}>{r.email}</a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

// ===== Contact =====
const Contact = ({ t }) => (
  <section id="contact" className="contact" data-testid="contact-section">
    <div className="container">
      <div className="contact__inner">
        <div className="contact__lead">
          <span className="eyebrow">{t.contact.eyebrow}</span>
          <h2 className="display contact__title">{t.contact.title}</h2>
          <p className="contact__sub">{t.contact.subtitle}</p>
        </div>
        <div className="contact__cards">
          <div className="contact-card contact-card--direct" data-testid="contact-direct">
            <span className="mono contact-card__label">{t.contact.directLabel}</span>
            <div className="contact-card__person">
              <img src={IMAGES.joni} alt="Joni Kajava" />
              <div>
                <h3>Joni Kajava</h3>
                <p>{t.team.joniTitle}</p>
              </div>
            </div>
            <div className="contact-card__links">
              <a href="tel:+358504759055">+358 50 475 9055</a>
              <a href="mailto:joni.kajava@arcticrebar.fi">joni.kajava@arcticrebar.fi</a>
            </div>
          </div>
          <div className="contact-card contact-card--office" data-testid="contact-office">
            <span className="mono contact-card__label">{t.contact.officeLabel}</span>
            <div className="contact-card__office">
              <h3>Arctic Rebar Oy</h3>
              <p>{t.contact.address1}</p>
              <p>{t.contact.address2}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

// ===== Footer =====
const Footer = ({ t }) => (
  <footer className="footer" data-testid="footer">
    <div className="container">
      <div className="footer__top">
        <div className="footer__brand-col">
          <img src={IMAGES.logo} alt="Arctic Rebar" />
          <p className="footer__positioning">{t.footer.positioning}</p>
        </div>
        <div>
          <span className="mono footer__col-label">{t.footer.contactLabel}</span>
          <div className="footer__col-list">
            <a href="mailto:joni.kajava@arcticrebar.fi">joni.kajava@arcticrebar.fi</a>
            <a href="tel:+358504759055">+358 50 475 9055</a>
            <a href="https://www.arcticrebar.fi" target="_blank" rel="noreferrer">www.arcticrebar.fi</a>
          </div>
        </div>
        <div>
          <span className="mono footer__col-label">{t.footer.officeLabel}</span>
          <div className="footer__col-list">
            <span>Arctic Rebar Oy</span>
            <span>{t.contact.address1}</span>
            <span>{t.contact.address2}</span>
          </div>
        </div>
      </div>
      <div className="footer__bottom mono">
        <span>© {new Date().getFullYear()} Arctic Rebar Oy</span>
        <span className="footer__rights">{t.footer.rights}</span>
      </div>
    </div>
  </footer>
);

// ===== App =====
function App() {
  const [lang, setLang] = useState("fi");
  const t = translations[lang];

  // Keep <html lang> in sync with active language for correct hyphenation & a11y
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  // Reveal-on-scroll
  useEffect(() => {
    const els = document.querySelectorAll("[data-reveal]");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [lang]);

  return (
    <div className="app" data-testid="app">
      <Navigation lang={lang} setLang={setLang} t={t} />
      <Hero t={t} />
      <Metrics t={t} />
      <Capabilities t={t} />
      <Projects t={t} />
      <Why t={t} />
      <Team t={t} />
      <Careers t={t} />
      <Contact t={t} />
      <Footer t={t} />
    </div>
  );
}

export default App;
